import angular from 'angular';

import sideMenuAnonymousTemplate from './side-menu-anonymous.html';
import sideMenuLoggedinTemplate from './side-menu-loggedin.html';
import SideMenuItems from './components/menu-items/menu-items';
import SideMenuHeaderModule from './components/side-menu-header/side-menu-header-module';

const mapStateToThis = ({ session, versionInfo, config }) => {
  const { homePageLogos = [], defaultLocale  } = config;
  const { locale } = session;
  return {
    session,
    versionInfo,
    homePageLogos,
    locale,
    defaultLocale,
  };
};

@Inject('$ngRedux', '$state', 'tmhDynamicLocale')
class SideMenuController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, {})(this);
  }

  $onInit() {
    this.logos = this.homePageLogos.filter((logo) => logo.enabled && logo.loggedIn);
    const locale = this.locale || this.defaultLocale;
    this.setDynamicLocale(locale);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onDownloadWidgetAttachment(widget) {
    this.api.downloadWidgetAttachment.run(widget);
  }

  setDynamicLocale(locale) {
    const formattedLocale = locale.toLowerCase().replace('_', '-');
    this.tmhDynamicLocale.set(formattedLocale);
  }
}

class SideMenuLoggedinComponent {
  constructor() {
    this.controller = SideMenuController;
    this.template = sideMenuLoggedinTemplate;
    this.bindings = {
      model: '<',
      api: '<',
      config: '<',
    };
    return this;
  }
}

class SideMenuAnonymousComponent {
  constructor() {
    this.controller = SideMenuController;
    this.template = sideMenuAnonymousTemplate;
    this.bindings = {
      model: '<',
      forgotUsername: '<',
      api: '<',
      config: '<',
    };
    return this;
  }
}

export default angular
  .module('side-menu', [
    SideMenuHeaderModule.name,
  ])
  .component('sideMenuItems', new SideMenuItems())
  .component('sideMenuLoggedin', new SideMenuLoggedinComponent())
  .component('sideMenuAnonymous', new SideMenuAnonymousComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/side-menu/side-menu-component.js